<template>
  <div class="hkl-form-item">
    <template name="label">
      <label
        class="hkl-form-item_label"
        :class="{'required-flag': canEdit ? required : false}"
      >
        {{ label }}
      </label>
    </template>
    <div class="hkl-form-item_body">
      <HKLFormItemContent>
        <slot />
      </HKLFormItemContent>
    </div>
  </div>
</template>
<script>
import { inject } from 'vue-demi'
import { PROVIDE_KEYS } from './consts'
import HKLFormItemContent from './HKLFormItemContent.vue'

export default {
  name: 'HKLFormItem',
  components: {
    HKLFormItemContent,
  },
  props: {
    label: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: () => false,
    },
  },
  setup () {
    const canEdit = inject(PROVIDE_KEYS.CAN_EDIT, true)
    return { canEdit }
  },
}
</script>

<style lang="scss" scoped>

.hkl-form-item_body {
  word-break: break-all
}
</style>
